<app-popup-card-base-layout
    [shadow]="'strong'"
    [hasBorder]="hasBorder"
    (keyup.escape)="onCloseClicked()"
    tabindex="-1"
    cdkFocusInitial
>
    <div class="container">
        <div class="header">
            <div class="headerContent">
                @if (showEventInfo) {
                    <div class="eventInfo">
                        <lib-badge
                            [text]="data?.eventType === dueDatetype ? 'Due Date' : 'Follow up'"
                            [color]="data?.eventType === dueDatetype ? 'secondary' : 'tertiary'"
                        >
                        </lib-badge>
                        @if (data?.eventDate) {
                            <span class="dateInfo">
                                {{ $safeNavigationMigration(data?.eventDate) | date: 'EE, MMM d h:mm a' }}
                            </span>
                        }
                    </div>
                }
                <div class="title">{{ data?.name }}</div>
                <div class="code">ID {{ data?.id }}</div>
            </div>
            @if (allowCloseCard) {
                <button
                    (click)="onCloseClicked()"
                    [innerHTML]="closeIcon"
                    class="resetStyles closeButton"
                    aria-label="Close panel"
                ></button>
            }
        </div>

        <hr />

        <div class="body">
            <ul>
                @if (data?.opportunityStatusName) {
                    <li>
                        <span class="label">Status</span>
                        <span class="value">{{ data?.opportunityStatusName }}</span>
                    </li>
                }
                @if (data?.eventType === dueDatetype) {
                    @if (data?.eventDate) {
                        <li>
                            <span class="label">Due Date</span>
                            <span class="value">{{
                                $safeNavigationMigration(data?.eventDate) | date: 'M/d/yyyy'
                            }}</span>
                        </li>
                    }
                    @if (data?.companyName) {
                        <li>
                            <span class="label">Customer</span>
                            <span class="value">{{ data?.companyName }}</span>
                        </li>
                    }
                    @if (data?.opportunityUsers?.length) {
                        <li>
                            <span class="label">Salesperson</span>
                            <span
                                ><app-user-info
                                    [users]="$any($safeNavigationMigration(data?.opportunityUsers))"
                                    [tooltipUseParentForPositioning]="true"
                                ></app-user-info>
                            </span>
                        </li>
                    }
                    @if (data?.opportunityValue) {
                        <li>
                            <span class="label">Opportunity Value</span>
                            <span class="value">{{ $safeNavigationMigration(data?.opportunityValue) | currency }}</span>
                        </li>
                    }
                }
                @if (data?.eventType === followUpType && data?.contactInfo) {
                    <li>
                        <span class="label">Contact</span>
                        <span class="value">{{ data?.contactInfo }}</span>
                    </li>
                }
            </ul>
        </div>
        <div class="footer">
            <button class="btn primary-btn" (click)="onGoToClicked()">Go to Opportunity</button>
        </div>
    </div>
</app-popup-card-base-layout>
